import { render, staticRenderFns } from "./WidgetProductReviewsPhotoThumbnailMobile.vue?vue&type=template&id=f2dd2b02"
import script from "./WidgetProductReviewsPhotoThumbnailMobile.vue?vue&type=script&lang=js"
export * from "./WidgetProductReviewsPhotoThumbnailMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports